// extracted by mini-css-extract-plugin
export var layout = "Layout-module--layout--LJM9v";
export var main = "Layout-module--main--IApBM";